module.exports = __webpack_public_path__ + "img/dog-personalised.02a3adf2.png";